export default "__VITE_ASSET__BvML8XRq__"